import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import { IncidentReportDto } from '@services';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { UserAvatarEmailComponent } from '../../../../../../components/utils/user-avatar-email/user-avatar-email.component';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';

@Component({
    selector: 'app-approvals-section',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
        UserAvatarEmailComponent,
    ],
    templateUrl: './approvals-section.component.html',
})
export class ApprovalsSectionComponent {
    @Input() incidentReport: IncidentReportDto;

    public dateTimeFormat = DATE_TIME_FORMAT;
}
